// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1M7wa","errorLogs":"EditorFooter_errorLogs__TtCEx"};